import React from "react";
import { FormProvider } from "react-hook-form";
import { Stack, Typography } from "@mui/material";

import { RFHToggle as RHFToggle } from "../../../components/RFH";
import { CustomButton } from "../../../components/Button/Button";
import { usePlannerSettingsForm } from "./hooks/usePlannerSettingsForm";

function PlannerSettings({ initialData }) {
  const { methods, isPending, hasChanges, onSubmit } =
    usePlannerSettingsForm(initialData);

  return (
    <>
      <FormProvider {...methods}>
        <div className="mt-32 form-section">
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <div>
              <Typography className="setting-heading mb-2 ml-0">
                Planner Settings
              </Typography>
            </div>
            <div className="d-flex mt-32 align-items-center">
              <div className="mr-4">
                <Typography className="setting-heading ml-0">
                When enabled, this planner is public. When disabled, it is private
                </Typography>
               
              </div>
              <div className="ml-2">
                <RHFToggle name="planner_token_sharing_enabled" />
              </div>
            </div>
            <Stack alignItems="end" className="mt-32">
              <CustomButton
                variant="contained"
                type="submit"
                className="theme-bg-color working-hours-update-button"
                disabled={isPending || !hasChanges()}
              >
                Update
              </CustomButton>
            </Stack>
          </form>
        </div>
      </FormProvider>
    </>
  );
}

export default React.memo(PlannerSettings);
